export default __webpack_public_path__ + "static/media/instagram_icon.9adff1de.svg";